var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInverterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90.89 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:url(#e);}.g,.h,.i,.j,.k{stroke-miterlimit:10;stroke-width:.5px;}.g,.h,.i,.k{stroke:#fff;}.h{fill:url(#f);}.i{fill:#fff;}.j{stroke:#084c7e;}.j,.k{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 7.24,
    y1: 17.75,
    x2: 64.24,
    y2: 17.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afafaf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 17.18,
    cy: 47.69,
    fx: 17.18,
    fy: 47.69,
    r: 42.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M74.43,30.24c-.12,.03-.25,.07-.37,.07-1.38-.01-2.77-.03-4.15-.06-.75-.02-1.04-.44-1.01-1.11,.05-1.05-.01-2.11-.03-3.17,0-.33-.12-.69,0-.97,.1-.24,.44-.53,.69-.54,1.38-.05,2.76-.03,4.16,.07-.12,.02,.67,.05,.55,.05-.55,0-2-.03-2.54-.03-.87,0-.9,.06-.85,.87,.03,.41,.24,.52,.64,.52,.71,0,1.43,.02,2.14,0,.44,0,.58,.19,.58,.57-.01,.65-.04,1.31,0,1.96,.03,.48-.24,.62-.66,.63-.55,.01-1.09,0-1.64,0-1.04,0-1.05,.02-1.02,1.02h3.49v.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M74.43,90.79c-.12,.03-.25,.07-.37,.07-1.38-.01-2.77-.03-4.15-.06-.75-.02-1.04-.44-1.01-1.11,.05-1.05-.01-2.11-.03-3.17,0-.33-.12-.69,0-.97,.1-.24,.44-.53,.69-.54,1.39-.05,2.95-.01,4.16,.07-.12,.02,.67,.05,.55,.05-.55,0-2-.03-2.54-.03-.87,0-.9,.06-.85,.87,.03,.41,.24,.52,.64,.52,.71,0,1.43,.02,2.14,0,.44,0,.58,.19,.58,.57-.01,.65-.04,1.31,0,1.96,.03,.48-.24,.62-.66,.63-.55,.01-1.09,0-1.64,0-1.04,0-1.05,.02-1.02,1.02h3.49v.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M7.68,78.74c.12-.03,.25-.07,.37-.07,1.38,.01,2.77,.03,4.15,.06,.75,.02,1.04,.44,1.01,1.11-.05,1.05,.01,2.11,.03,3.17,0,.33,.12,.69,0,.97-.1,.24-.44,.53-.69,.54-1.38,.05-2.76,.03-4.16-.07,.12-.02-.67-.05-.55-.05,.55,0,2,.03,2.54,.03,.87,0,.9-.06,.85-.87-.03-.41-.24-.52-.64-.52-.71,0-1.43-.02-2.14,0-.44,0-.58-.19-.58-.57,.01-.65,.04-1.31,0-1.96-.03-.48,.24-.62,.66-.63,.55-.01,1.09,0,1.64,0,1.04,0,1.05-.02,1.02-1.02h-3.49v-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M7.24,35.25v-13L20.24,.25h13c0,4,0,5,3,5v7c0,1.99,4,2.01,4,0V3.25c-.12-1.51-1-2-4-2V.25h28V15.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M68.7,78.63l.88-1.23h1.2l.73,1.23h19.13v-15.15h-19.13l-.73,1.23h-1.3l-.78-1.23h-.77v-11.35h.98l.8-1.23h1.1l.66,1.23h17.48v-15.15h-17.48l-.66,1.23h-1.19l-.71-1.23h-1.16v-5.8h8.14c.34,0,.62-.28,.62-.62v-6.51c0-.34-.28-.62-.62-.62h-8.14l.07-5.65c.01-1.12-.89-2.03-2-2.03H29.81c-1.11,0-2,.9-2,2.01v3.92H14.84c-.58,0-1.05,.47-1.05,1.06l.08,8.37c1.33,.14,1.46,1.79-.08,1.84v.3c-.08,0-.17,0-.25,0-7.34,0-13.29,5.98-13.29,13.35s5.95,13.35,13.29,13.35c.08,0,.17,0,.25,0v18.09H6.52c-.34,0-.62,.28-.62,.62v5.3c0,.53,.44,.97,.97,.97h7.09v6.69c0,.38,.2,.75,.55,.91,.57,.28,.94,.91,1.14,1.85,.05,.22,.24,.39,.47,.39h51.05c.71,0,1.29-.58,1.29-1.29v-1.9h6.92c.34,0,.62-.28,.62-.62v-5.91c0-.34-.28-.62-.62-.62h-7.62l.07-5.78h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.24,3.25V12.25c0,2,4,2,4,0V3.25c0-2-4-2-4,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 14.24,
    y1: 60.25,
    x2: 61.24,
    y2: 60.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M31.95,33.25v-13.31c0-.93,.76-1.69,1.69-1.69h25.91c.93,0,1.69,.76,1.69,1.69v13.31H13.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 52.74,
    cy: 48.75,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M32.24,35.25h29c1,0,1,2,0,2h-13v5c0,2-4,2-4,0v-5h-12c-1,0-1-2,0-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M20.24,62.25H63.24v24.65c0,2.4-1.95,4.35-4.35,4.35H24.59c-2.4,0-4.35-1.95-4.35-4.35v-24.65h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverterIcon);
export default __webpack_public_path__ + "static/media/InverterIcon.01d96a399b6d347d31b5ae1d832bfbc7.svg";
export { ForwardRef as ReactComponent };